import { defineComponent as d, provide as i, toRef as l, computed as n, createElementBlock as f, openBlock as p, normalizeClass as m, renderSlot as u } from "vue";
import { tw as t } from "../../utils/tailwind.js";
import { listVariantInjectionKey as c } from "./List.constant.js";
const B = /* @__PURE__ */ d({
  name: "RevList",
  __name: "List",
  props: {
    hideDividers: { type: Boolean, default: !1 },
    hasExternalBorders: { type: Boolean, default: !0 },
    hideExternalBordersOn: { default: void 0 },
    variant: { default: "default" }
  },
  setup(s) {
    const e = s;
    i(c, l(e, "variant"));
    const a = n(() => {
      const r = [t`border-static-default-low`];
      return e.hasExternalBorders && (e.hideExternalBordersOn ? (r.push(t`first-of-type:border-t last-of-type:border-y`), e.hideExternalBordersOn === "sm" && r.push(t`md:border-y`), e.hideExternalBordersOn === "md" && r.push(t`lg:border-y`)) : r.push(t`border-y`)), [e.hideDividers && e.variant === "compact" ? "" : t`divide-static-default-low divide-y`, ...r];
    });
    return (r, o) => (p(), f("ul", {
      class: m(a.value)
    }, [
      u(r.$slots, "default")
    ], 2));
  }
});
export {
  B as default
};
